import React, { ReactNode } from "react";
import MenuIcon from "@mui/icons-material/Menu";

interface MobileMenuProps {
  overlayMenu: boolean;
  setOverlayMenu: (value: boolean) => void;
  clickmenu: boolean;
  setClickMenu: (value: boolean) => void;
  children: ReactNode;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ overlayMenu, setOverlayMenu, clickmenu, setClickMenu, children }) => (
  <div className="mobile-menu-root">
    {/* Always show the menu toggle button */}
    <div
      className="mobile-menu-toggle z-20 cursor-pointer"
      onClick={() => setClickMenu(!clickmenu)}
      style={{
        position: "absolute",
        top: "15px",
        left: "10px",
        zIndex: 1000,
        background: "transparent",
      }}
    >
      <MenuIcon fontSize="large" />
    </div>

    {/* Overlay menu */}
    <nav className={`mobile-menu-overlay${clickmenu ? " collapsed" : ""}`}>
      <ul className="mobile-menu-content">{children}</ul>
    </nav>
  </div>
);

export default MobileMenu;
